<button class="dropdown-trigger" type="button" [class.open]="open()" (click)="toggle()">
  @if (triggerLabel()) {
    <span class="dropdown-caption">{{ triggerLabel() }}</span>
  }
  <app-dropdown-chevron [open]="open()" />
</button>

@if (open()) {
  <div class="dropdown-menu">
    <ng-container *ngTemplateOutlet="menu()?.templateRef" />
  </div>
}
